import { Box, Button, Chip, styled, Typography } from '@material-ui/core';
import { Palette } from '@material-ui/core/styles/createPalette';
import { InvitationStatus } from './types';

export const PendingCountChip = styled(Chip)(({ theme }) => ({
  height: 25,
  minWidth: 16,
  backgroundColor: `${theme.palette.error.main} !important`,
  marginBottom: 16,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  verticalAlign: 'middle',
  '& .MuiChip-label': {
    paddingLeft: 6,
    paddingRight: 6,
    fontWeight: 700,
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'visible',
    textOverflow: 'clip',
  },
}));

export const PageTitle = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

export const ChipContainer = styled(Box)({
  display: 'flex',
  flexWrap: 'nowrap',
  gap: 8,
  alignItems: 'center',
  overflow: 'hidden',
  width: '100%',
  minWidth: 0,
});

export const PrimaryChip = styled(Chip)({
  flexShrink: 1,
  minWidth: 0,
  maxWidth: '100%',
  '& .MuiChip-label': {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

export const OverflowIndicator = styled('span')({
  flexShrink: 0,
});

export const OverflowChip = styled(Chip)({
  flexShrink: 0,
});

export const EmailText = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const StatusContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
});

export const getInvitationStatusColor = (
  status: InvitationStatus,
  palette: Palette,
): string => {
  const colorByStatus: Record<InvitationStatus, string> = {
    pending: palette.warning.main,
    accepted: palette.success.main,
    rejected: palette.error.main,
    expired: palette.error.main,
    revoked: palette.error.main,
  };

  return colorByStatus[status];
};

export const ActionsContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  flexWrap: 'nowrap',
});

export const ActionButton = styled(Button)({
  textTransform: 'capitalize',
});
